import { FaChevronLeft, FaChevronRight, FaClipboardList, FaInfoCircle } from "react-icons/fa";
import Button from "../../../components/Button";

export const Step2Topics = ({
  formData,
  updateForm,
  prevStep,
  nextStep
}) => {
  return (
    <div className="space-y-6">
      <div className="border-l-4 border-l-primary pl-4">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <FaClipboardList className="w-5 h-5 text-primary" />
          </div>
          <h2 className="text-xl sm:text-2xl font-bold text-text">
            Topics to Focus On
          </h2>
        </div>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 flex gap-3">
        <FaInfoCircle className="text-blue-600 w-5 h-5 flex-shrink-0 mt-0.5" />
        <div className="text-sm text-blue-900">
          <p className="font-medium mb-1">Optional but Recommended</p>
          <p className="text-blue-800">
            Mentioning specific topics helps your tutor prepare better.
          </p>
        </div>
      </div>

      <div className="space-y-2">
        <label className="flex items-center gap-2 text-sm font-semibold text-text">
          <FaClipboardList className="w-4 h-4 text-primary" />
          Topics/Areas to Focus (Optional)
        </label>
        <textarea
          value={formData.topicsToFocus}
          onChange={(e) =>
            updateForm({ topicsToFocus: e.target.value })
          }
          placeholder="Enter topics you'd like to focus on..."
          rows={6}
          maxLength={1000}
          className="w-full px-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary bg-surface text-text resize-none"
        />
        <div className="flex justify-between text-xs text-text/50">
          <span>One topic per line</span>
          <span>{formData.topicsToFocus.length}/1000 characters</span>
        </div>
      </div>

      <div className="flex gap-3 pt-4">
        <Button
          type="button"
          onClick={prevStep}
          variant="outline"
          className="w-full sm:w-auto"
        >
          <FaChevronLeft className="mr-2 w-4 h-4" />
          Back
        </Button>
        <Button
          type="button"
          onClick={nextStep}
          className="flex-1 sm:flex-initial"
        >
          Continue
          <FaChevronRight className="ml-2 w-4 h-4" />
        </Button>
      </div>
    </div>
  );
};
